import { render, staticRenderFns } from "./TrSlider.vue?vue&type=template&id=2678a15c&"
import script from "./TrSlider.vue?vue&type=script&lang=js&"
export * from "./TrSlider.vue?vue&type=script&lang=js&"
import style0 from "./TrSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports